import * as BuyerActivitySummaryContant from './BuyerActivitySummaryContants';
import { BuyerActivitySummaryState } from './BuyerActivitySummaryTypes';

export default (
  state = BuyerActivitySummaryContant.DEFAULT_STATE,
  action: any,
): BuyerActivitySummaryState => {
  switch (action.type) {
    case BuyerActivitySummaryContant.BuyerActivitySummaryActionTypes.LOADED_BUYER_ACTIVITY:
      return { ...state, buyerActivitySummary: action.payload, reloadBuyerActivity: false };
    case BuyerActivitySummaryContant.BuyerActivitySummaryActionTypes
      .LOADED_BUYER_ACTIVITY_SPLIT_SCENARIOS:
      return { ...state, splitScenarios: action.payload, reloadSplitScenarios: false };
    case BuyerActivitySummaryContant.BuyerActivitySummaryActionTypes.LOAD_BUYER_ACTIVITY_ERROR:
      return { ...state, reloadBuyerActivity: true };
    case BuyerActivitySummaryContant.BuyerActivitySummaryActionTypes
      .LOAD_BUYER_ACTIVITY_SPLIT_SCENARIOS_ERROR:
      return { ...state, reloadSplitScenarios: true };
    case BuyerActivitySummaryContant.BuyerActivitySummaryActionTypes.SELECT_SPLIT_SCENARIOS:
      return { ...state, selectedOption: action.payload };
    default:
      return state;
  }
};
